import { Component, Vue } from 'vue-property-decorator'

@Component({
  template: require('template/component/copyright.html'),
  components: {}
})
export default class Copyright extends Vue {

}
